import type { RatingAspect } from '../review';

export enum QuestionType {
  CHECKBOX = 'checkbox',
  DATE = 'date',
  DRAGGABLE_LIST = 'draggable-list',
  MULTIPLE_CHOICE = 'multiple-choice',
  NUMBER = 'number',
  RATING = 'rating',
  SHORT_TEXT = 'short-text',
  TAG_INPUT = 'tag-input',
  TEXT = 'text',
}

export enum QuestionValidationRules {
  MINIMUM_CHARACTERS = 'minimum-characters',
  REQUIRED = 'required',
}

export interface CheckboxQuestion extends Question {
  options: string[];
  type: QuestionType.CHECKBOX;
}

export interface ConditionalShowRules {
  compareTo?: string;
  comparison?: 'equalTo' | 'greaterThan' | 'lessThan';
  field: string;
  notValues?: string[];
  value: string;
}

export interface DateQuestion extends Question {
  name: string;
  question: string;
  type: QuestionType.DATE;
}

export interface DraggableListQuestion extends Question {
  placeholder: string;
  type: QuestionType.DRAGGABLE_LIST;
}

export interface MultipleChoiceQuestion extends Question {
  options: string[];
  type: QuestionType.MULTIPLE_CHOICE;
}
export interface Question {
  conditionallyShow?: boolean;
  conditionalShowRules?: Array<ConditionalShowRules>;
  helperText?: string;
  name: string;
  question: string;
  required?: boolean;
  tooltipText?: string;
  type: QuestionType;
  validationRules?: Array<QuestionValidationRules>;
}

export interface RatingQuestion extends Question {
  label: string;
  name: string;
  responseName: RatingAspect;
  shortLabel: string;
}

export interface RatingQuestion extends Question {
  max?: number;
  min?: number;
  type: QuestionType.RATING;
}

export interface ShortTextQuestion extends Question {
  type: QuestionType.SHORT_TEXT;
}

export interface TextQuestion extends Question {
  type: QuestionType.TEXT;
}
